import * as React from 'react';
import { StyleProp, View, ViewStyle, Text, StyleSheet } from 'react-native';
import Svg, {
  ClipPath,
  Defs,
  Ellipse,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
} from 'react-native-svg';

const StreakBadgeNoRect = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
    number?: number;
    numberFontSize?: number;
    topNumberPos?: string | number;
    unitLabel?: string;
    unitLabelFontSize?: number;
    topuUnitLabelPos?: string | number;
  }) => {
    const {
      width = 33,
      height = 42,
      containerStyle,
      number,
      numberFontSize = 7,
      topNumberPos = 57,
      unitLabel = 'days',
      unitLabelFontSize = 5,
      topuUnitLabelPos = 28,
    } = props;

    return (
      <View style={[{ width, height }, containerStyle]}>
        <Svg width={width} height={height} viewBox="0 0 33 42" fill="none">
          <G clipPath="url(#clip0_3448_132795)">
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.57108 0.796875H26.5216L26.505 0.826468L32.1227 7.88928L24.373 21.0449C26.3121 23.1855 27.4928 26.0099 27.4928 29.1106C27.4928 35.7887 22.0182 41.2009 15.2631 41.2009C8.50795 41.2009 3.03333 35.7887 3.03333 29.1106C3.03333 25.5036 4.63314 22.2648 7.16756 20.0519L0 7.88928L5.60101 0.846196L5.57108 0.796875ZM17.9605 17.3162L26.2622 1.22104L22.6468 7.0837H9.43258L6.01344 1.51697L14.0424 17.0795C14.4449 17.04 14.8507 17.0203 15.2631 17.0203C16.191 17.0203 17.0924 17.1222 17.9605 17.3162ZM15.2631 19.5653C20.5947 19.5653 24.9185 23.8365 24.9185 29.1106C24.9185 34.3847 20.5947 38.6559 15.2631 38.6559C9.93148 38.6559 5.60766 34.3814 5.60766 29.1106C5.60766 23.8365 9.93148 19.5653 15.2631 19.5653Z"
              fill="black"
            />
            <G filter="url(#filter0_i_3448_132795)">
              <Ellipse cx="15.3451" cy="28.7565" rx="10.9779" ry="11.0221" fill="#D0651B" />
            </G>
            <Path
              d="M15.3447 16.9473C21.8455 16.9473 27.1104 22.2376 27.1104 28.7568C27.1102 35.2759 21.8454 40.5664 15.3447 40.5664C8.84423 40.5662 3.58026 35.2758 3.58008 28.7568C3.58008 22.2377 8.84411 16.9475 15.3447 16.9473Z"
              stroke="url(#paint0_linear_3448_132795)"
              strokeWidth="1.5748"
            />

            <G clipPath="url(#clip1_3448_132795)">
              <Ellipse cx="24.9448" cy="36.4764" rx="2.23972" ry="3.14823" fill="#FB7D24" />
              <Path
                d="M28.517 34.8838C27.5793 32.4371 24.2407 32.3052 25.047 28.7492C25.1067 28.4854 24.826 28.2815 24.599 28.4194C22.431 29.7027 20.8721 32.2752 22.1801 35.6453C22.2876 35.9212 21.9651 36.179 21.7322 35.9991C20.6512 35.1776 20.5377 33.9963 20.6332 33.1507C20.6691 32.8389 20.2629 32.689 20.0897 32.9469C19.6836 33.5705 19.2715 34.5779 19.2715 36.0951C19.4984 39.4532 22.3235 40.4846 23.3388 40.6165C24.7902 40.8024 26.3609 40.5326 27.4898 39.4952C28.7321 38.3378 29.186 36.4909 28.517 34.8838ZM22.9745 37.9001C23.8345 37.6902 24.2765 37.0665 24.396 36.5149C24.5931 35.6573 23.8226 34.8178 24.3422 33.4626C24.5393 34.5839 26.2952 35.2855 26.2952 36.5089C26.343 38.026 24.7065 39.3273 22.9745 37.9001Z"
                fill="#FFC442"
              />
            </G>
          </G>
          <Defs>
            <LinearGradient
              id="paint0_linear_3448_132795"
              x1="15.3451"
              y1="17.7344"
              x2="15.3451"
              y2="39.7786"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stopColor="#FF9900" />
            </LinearGradient>
            <ClipPath id="clip0_3448_132795">
              <Rect width="32.126" height="40.404" fill="white" transform="translate(0 0.796875)" />
            </ClipPath>
            <ClipPath id="clip1_3448_132795">
              <Rect
                width="14.3342"
                height="14.3919"
                fill="white"
                transform="translate(16.8828 27.4766)"
              />
            </ClipPath>
          </Defs>
        </Svg>

        {/* Number overlay */}
        {number !== undefined && (
          <>
            <Text style={[styles.number, { fontSize: numberFontSize, top: topNumberPos }]}>
              {number}
            </Text>
            <Text
              style={[styles.unitLabel, { fontSize: unitLabelFontSize, top: topuUnitLabelPos }]}
            >
              {unitLabel}
            </Text>
          </>
        )}
      </View>
    );
  },
);

const styles = StyleSheet.create({
  number: {
    position: 'absolute',
    left: 0,
    right: 0,
    textAlign: 'center',
    fontWeight: '400',
    color: '#ffffff',
    fontFamily: 'Secular One',
  },

  unitLabel: {
    position: 'absolute',
    left: 0,
    right: 0,
    textAlign: 'center',
    fontWeight: '400',
    color: '#ffffff',
    fontFamily: 'Secular One',
  },
});

export { StreakBadgeNoRect };
